import { dictionary } from 'helpers/dictionary'

export function parsePortName(name) {
  const split = name ? name.split(' ')[0] : name

  switch (split) {
    case 'Dobroviz':
      return dictionary('scDryDock')
    case 'Bousso':
      return dictionary('scOutOfService')
    case 'Outeiro':
      return dictionary('scOutOfService')
    case 'Infosys':
      return dictionary('scIntoService')
    case 'Nancowrie':
      return dictionary('scIntoService')
    case 'Ivancice':
      return dictionary('scISCoastalService')
    case 'Shipai':
      return dictionary('scISCoastalService')
    default:
      return split.replaceAll('ø', 'ö') // This title fix is temporary until they fix the service.
  }
}

// TODO: Clean this up when the service is fixed.

// BR OUT
// Outeiro = Out of service / Úr þjónustu

// IN NAN
// Nancowrie = Into service / Í þjónustu

// CN SPI
// Shipai // = IS Coastal Service / Strandleið

// CZ DDD
// Dry dock
